import { Collection } from '../../api/collections';
import { Button } from '../ui/Button';

interface CollectionCardProps {
  collection: Collection;
  onView: (id: string) => void;
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

export function CollectionCard({ collection, onView, onEdit, onDelete }: CollectionCardProps) {
  return (
    <div className="collection-card" onClick={() => onView(collection.id)}>
      <div className="collection-card-header">
        <div className="collection-color-dot" style={{ backgroundColor: collection.color || '#C45C26' }} />
        <h3 className="collection-card-title">{collection.name}</h3>
      </div>
      <p className="collection-card-meta">
        {collection.recipe_count || 0} recipe
        {(collection.recipe_count || 0) !== 1 ? 's' : ''}
      </p>
      <div className="collection-card-actions" onClick={e => e.stopPropagation()}>
        <Button variant="ghost" size="sm" onClick={() => onView(collection.id)}>
          View Recipes
        </Button>
        <Button variant="ghost" size="sm" onClick={() => onEdit(collection.id)}>
          Edit
        </Button>
        <Button variant="ghost" size="sm" className="text-error" onClick={() => onDelete(collection.id)}>
          Delete
        </Button>
      </div>
    </div>
  );
}
